import Enum from './enum'

class ChangedSection extends Enum
{
  constructor(value) {
    super(value);
  }
}

ChangedSection.init({
  SPECIFICATION: 'specification',
  CRITERION: 'criterion',
  DOCUMENT: 'document'
},
{
  SPECIFICATION: 'changed-section.specification',
  CRITERION: 'changed-section.criterion',
  DOCUMENT: 'changed-section.document'
});

export default ChangedSection;
